var exports = {
  "kL": "x61f99309--f5248f--container",
  "Tf": "x61f99309--f5248f--container-redesigned",
  "my": "x61f99309--f5248f--avatar",
  "pq": "x61f99309--f5248f--info",
};

module.exports = exports;
